// extracted by mini-css-extract-plugin
module.exports = {"markdown":"_6d9832ac pr4-ns pl0-ns ph1-m pr3-m pr2","heading-link":"_5a6c64a6"};